module.exports = __webpack_public_path__ + "media/images/competitions/trophy-06f5789fba6000b2b601924037ee87da.png";